
module.exports = {
   'admin' : {
       'code' : 'PMG9999',
       'name' : 'admin',
       'ward' : 'admin',
       'resident' : 'พ.เฉลิมพล test',
       'division' : 'Trauma',
       'password' : '363716'
   },
    'tmkku' : {
       'code' : 'TMKKU',
        'name' : 'TMKKU',
        'ward' : 'AE01',
        'resident' : 'พ.เฉลิมพล test',
        'division' : 'Trauma',
        'password' : '3716'
    }
};
